export const NexusTracker = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_298_26272)">
      <path
        d="M12.8333 7.27825V9.33333H9.28317L5.83333 5.8835V1.16667H6.92125C7.12367 0.784 7.38383 0.429333 7.69883 0.114333C7.73908 0.0740833 7.78342 0.0385 7.82483 0H1.75C0.785167 0 0 0.785167 0 1.75V14H14V6.17458C13.9609 6.21658 13.9253 6.26092 13.8845 6.30175L12.8333 7.27767V7.27825ZM1.75 1.16667H4.66667V5.775L1.16667 7.64108V1.75C1.16667 1.428 1.42858 1.16667 1.75 1.16667ZM1.16667 8.96408L5.14325 6.84308L8.27167 9.9715L6.12558 12.8333H1.16667V8.96408ZM7.58333 12.8333L9.33333 10.5H12.8333V12.8333H7.58333ZM9.91667 3.21183C9.91667 2.72883 10.3087 2.33683 10.7917 2.33683C11.2747 2.33683 11.6667 2.72883 11.6667 3.21183C11.6667 3.69483 11.2747 4.08683 10.7917 4.08683C10.3087 4.08683 9.91667 3.69483 9.91667 3.21183ZM8.54525 5.4985L10.7917 7.58217L13.0602 5.47692C13.6663 4.87142 14 4.06583 14 3.20833C14 2.35083 13.6663 1.54525 13.0602 0.93975C12.4547 0.333667 11.6492 0 10.7917 0C9.93417 0 9.12858 0.333667 8.52308 0.93975C7.917 1.54525 7.58333 2.35083 7.58333 3.20833C7.58333 4.06583 7.91933 4.87317 8.54525 5.4985ZM9.34792 1.76517C9.7335 1.37958 10.2457 1.16725 10.7917 1.16725C11.3377 1.16725 11.8492 1.37958 12.2354 1.76517C12.6216 2.15075 12.8333 2.66292 12.8333 3.20892C12.8333 3.75492 12.621 4.2665 12.2512 4.63692L10.7917 5.99083L9.35433 4.6585C8.96467 4.26883 8.75 3.75433 8.75 3.20892C8.75 2.6635 8.96233 2.15133 9.34792 1.76517Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_298_26272">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
